module.exports = __webpack_public_path__ + "bda8a9396ac0e5020e8c8b2d179dfc88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000P8A.png
// module id = 1627
// module chunks = 0